var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { SiteMenuBar, SiteSidebar, useLang, useReady, useSiteSidebar } from '@shapeable/ui';
import { useMapState, useMapUtils } from '../hooks/use-map-state';
import { EntityMap } from './entity-map';
import { useMapConfig } from '../context/map-config-context';
export var EntityMapPanelDefaultProps = {
  chromeWidth: 0
};
// -------- Styles --------> 
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    min-width: 320px;\n    width: 100vw;\n    height: 100vh;\n    background: #0D1116;\n    position: fixed;\n    display: flex;\n    align-items: stretch;\n    justify-content: stretch;\n    left: 200vw;\n    transition: left 0.3s;\n    top: 0;\n    z-index: 600;\n\n    ", "\n  "], ["\n    min-width: 320px;\n    width: 100vw;\n    height: 100vh;\n    background: #0D1116;\n    position: fixed;\n    display: flex;\n    align-items: stretch;\n    justify-content: stretch;\n    left: 200vw;\n    transition: left 0.3s;\n    top: 0;\n    z-index: 600;\n\n    ", "\n  "])), function (_a) {
    var isExpanded = _a.isExpanded;
    return isExpanded && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      left: 0;\n    "], ["\n      left: 0;\n    "])));
  })
});
var BodyStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    flex-grow: 1;\n    display: flex;\n    color: #FFF;\n    align-items: center;\n    justify-content: center;\n\n    \n    .gatsby-image-wrapper img {\n      object-fit: contain !important;\n      box-sizing: border-box; !important;\n    };\n  "], ["\n    flex-grow: 1;\n    display: flex;\n    color: #FFF;\n    align-items: center;\n    justify-content: center;\n\n    \n    .gatsby-image-wrapper img {\n      object-fit: contain !important;\n      box-sizing: border-box; !important;\n    };\n  "])))
});
var MenuBarStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 400;\n    box-shadow: 0 1px 4px -2px rgba(0,0,0,0.7);\n    \n    .shp--slice-layout {\n      width: 100%;\n    }\n\n    ", "\n    \n  "], ["\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 400;\n    box-shadow: 0 1px 4px -2px rgba(0,0,0,0.7);\n    \n    .shp--slice-layout {\n      width: 100%;\n    }\n\n    ", "\n    \n  "])), function (_a) {
    var _chromeWidth = _a._chromeWidth;
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      min-width: ", "px;\n      width: calc(100% - ", "px);\n    "], ["\n      min-width: ", "px;\n      width: calc(100% - ", "px);\n    "])), 320 - _chromeWidth, _chromeWidth);
  })
});
var SidebarStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    z-index: 450;\n    height: 100%;\n    position: fixed;\n    right: 0;\n    top: 0;\n  "], ["\n    z-index: 450;\n    height: 100%;\n    position: fixed;\n    right: 0;\n    top: 0;\n  "])))
});
var MapStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  MenuBar: styled(SiteMenuBar)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), MenuBarStyles),
  Sidebar: styled(SiteSidebar)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), SidebarStyles),
  Map: styled(EntityMap)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), MapStyles)
};
export var EntityMapPanel = function (props) {
  var className = props.className,
    children = props.children,
    chromeWidth = props.chromeWidth,
    entityMapProps = __rest(props, ["className", "children", "chromeWidth"]);
  var title = useMapConfig().title;
  // const { isInverted, color } = useSiteMenuBar();
  var isReady = useReady().isReady;
  var hideOnClick = useMapUtils().hideOnClick;
  var _a = __read(useMapState(), 1),
    mapState = _a[0];
  var isVisible = mapState.isVisible;
  var t = useLang();
  var sidebar = useSiteSidebar();
  if (!isReady) {
    return null;
  }
  return React.createElement(My.Container, {
    isExpanded: isVisible,
    className: className
  }, React.createElement(My.MenuBar, {
    showCloseButton: true,
    onCloseClick: hideOnClick,
    boundary: "padding",
    _chromeWidth: chromeWidth || sidebar.width || 56,
    title: t(title)
  }), React.createElement(My.Body, null, React.createElement(My.Map, __assign({}, entityMapProps, {
    chromeWidth: chromeWidth,
    style: {
      width: '100%',
      marginRight: "".concat(chromeWidth, "px"),
      height: '100vh',
      visibility: isVisible ? 'visible' : 'hidden'
    }
  }), children)), isVisible && React.createElement(My.Sidebar, null));
};
EntityMapPanel.defaultProps = EntityMapPanelDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;